import { SelectOfferPage } from "@nju/feature-portal-additional-packages";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function Roaming() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="default" spacing="xl">
        <SelectOfferPage />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
